module.exports = __webpack_public_path__ + "img/gradient.d90d0da3.png";